import React from 'react';
import { Spinner } from './Spinner';

export function Loader() {
  return (
    <div className='flex justify-center p-3'>
      <Spinner />
    </div>
  );
}
